import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import ErrorBoundary from "#/components/ErrorBoundary";
import env from "#/env";
import Layout from "#/layout";
import * as species from "#/utils/SpeciesScope";
import "#/welcome";
import Content from "@/pages";
import { store } from "@/redux/store";

import "./i18n";
import "./scss/main.scss";

// configure global species filter for this app
species.set(species.CATTLE);

// ↓ This is used to replace the current history entry after sign-in
const signInCallback = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

ReactDOM.createRoot(document.getElementById("app")).render(
  <ErrorBoundary>
    <BrowserRouter
      basename={env.BASE_PATH || "/"}
      future={{ v7_relativeSplatPath: true }}>
      <AuthProvider
        authority={env.OIDC_AUTHORITY}
        client_id={env.OIDC_CLIENT_ID}
        redirect_uri={window.location.origin + window.location.pathname}
        post_logout_redirect_uri={window.location.origin} // Redirect URL after logout. In our case it will lead to log in again
        onSigninCallback={signInCallback}>
        <Provider store={store}>
          <Layout>
            <Content />
          </Layout>
        </Provider>
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
